if (!customElements.get('sticky-product-cta')) {
  customElements.define(
    'sticky-product-cta',
    class StickyProductCta extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.sticky-product-cta__button');
        this.priceWrapper = this.querySelector('.sticky-product-cta__price');
        this.spinner = this.button?.querySelector('.loading__spinner');
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onScrollOrResize = this.onScrollOrResize.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
        this.onCartSettled = this.onCartSettled.bind(this);
      }

      connectedCallback() {
        this.target = document.getElementById(this.dataset.targetId);
        if (!this.target || !this.button) return;

        this.button.addEventListener('click', this.onButtonClick);

        this.ticking = false;
        window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
        window.addEventListener('resize', this.onScrollOrResize);
        this.updateVisibility();

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartSettled);
        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, this.onCartSettled);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollOrResize);
        window.removeEventListener('resize', this.onScrollOrResize);
        this.variantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        this.cartErrorUnsubscriber?.();
      }

      get headerHeight() {
        const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        return parseInt(value) || 0;
      }

      onScrollOrResize() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
      }

      updateVisibility() {
        const scrolledPast = this.target.getBoundingClientRect().bottom < this.headerHeight;
        this.classList.toggle('sticky-product-cta--visible', scrolledPast);
        this.toggleAttribute('inert', !scrolledPast);
      }

      onButtonClick() {
        if (this.isSoldOut || this.button.getAttribute('aria-disabled') === 'true') return;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.spinner?.classList.remove('hidden');
        this.target.click();
      }

      onCartSettled() {
        this.button.classList.remove('loading');
        this.spinner?.classList.add('hidden');
        if (!this.isSoldOut) this.button.removeAttribute('aria-disabled');
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.dataset.sectionId) return;

        const { variant } = event.data;

        if (!variant) {
          this.setAvailability(false, window.variantStrings.unavailable);
          return;
        }

        this.setAvailability(variant.available, variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut);

        const sourcePrice = document.getElementById(`price-${event.data.sectionId}`);
        if (sourcePrice && this.priceWrapper) {
          this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }
      }

      setAvailability(available, text) {
        this.isSoldOut = !available;
        this.button.toggleAttribute('aria-disabled', !available);
        if (!available) this.button.setAttribute('aria-disabled', 'true');
        const label = this.button.querySelector('span');
        if (label && text) label.textContent = text;
      }
    }
  );
}